export default __webpack_public_path__ + "static/ml-solutions-bg-6985c38ddd4595077ab6b0b3bf02b549.webp";